module.exports = __webpack_public_path__ + "static/media/ios-apps.77b5497c.svg";